export default __webpack_public_path__ + "static/media/triangle.cd57d742.png";